import React, {FC} from 'react';

import {buildPrivateInboxCounterKey} from '../../../../helpers/counterHelpers';
import {buildTeammateInboxPath} from '../../../../helpers/modelHelpers';
import {DelegationModel} from '../../../../models/api/delegationModel';
import {InboxModel} from '../../../../models/api/inboxModel';
import {CountersVisibilityModesEnum} from '../../../../models/api/preferencesModel';
import {InboxesFiltersEnum} from '../../../../models/url/models/inboxesUrlModel';
import {InboxesPanelId} from '../../../../store/panels/panelStateBase';
import {WorkspaceInboxItemContainer} from '../workspaceInboxItemContainer';

/*
 * Props.
 */

interface DelegationWorkspaceInboxesProps {
  panelId: InboxesPanelId;
  delegation: DelegationModel;
  inboxes: ReadonlyArray<InboxModel>;
  indentLevel?: number;
  isDisabled?: boolean;
}

/*
 * Component.
 */

export const DelegationWorkspaceInboxes: FC<DelegationWorkspaceInboxesProps> = (props) => (
  <>
    {props.inboxes.map((i) => (
      <WorkspaceInboxItemContainer
        shouldHideMoreMenu
        canBeHidden={false}
        key={i.id}
        panelId={props.panelId}
        inbox={i}
        to={buildTeammateInboxPath(i.id, InboxesFiltersEnum.OPEN)}
        counterKey={buildPrivateInboxCounterKey(i.id)}
        countersVisibility={CountersVisibilityModesEnum.OPEN}
        counterDelegationId={props.delegation.id}
        indentLevel={props.indentLevel}
        isDisabled={props.isDisabled}
        shouldAlphabetizeWorkspace={false}
        shouldShowRefinedResultsIndicator={false}
        workspaceDragItem={undefined}
        selectedRefinement={undefined}
        hasEditPermission={false}
      />
    ))}
  </>
);
